import { createStore } from "vuex";
import axios           from "axios";
import { flatten }      from "lodash-es";

axios.defaults.headers.common = {
    'X-Requested-With' : 'XMLHttpRequest',
    'X-CSRF-TOKEN'     : document.querySelector( 'meta[name="csrf-token"]' ).getAttribute( 'content' ),
};

let state =
        {
            ready     : false,
            copydeck  : {},
            user      : {},
            form      : {},
            datastore : {},


            currentGroup : 0,
            totalGroup   : 0,

            avatars      : [],
            availableAvatars      : [],
            avatarFrames : [],
            availableFrames : [],

            defaultAvatarId : 0,
        };

let getters =
        {

            dataStoreThemes ( state )
            {
                return state.datastore?.themes ?? [];
            },

            allFields ( state )
            {
                return flatten(state.form.data.groups.map( g => g.fields ));
            },


        };


let actions =
        {
            async validateCurrentGroup ( { commit, state } )
            {
                let group  = state.form.data.groups[ state.currentGroup ];
                let fields = group.fields;

                let id   = state.form.id
                let data = fields
                    .map( f => ({ field : f.key, value : state?.user?.profile?.[ f.key ] ?? '' }) )
                    //.flat();

                data = flatten(data);

                let payload = { id, data };

                let response = await axios.post( "/endpoints/form/validate", payload );


                return response.data;
            },


            async updateUserProfile ( { commit }, payload )
            {
                let response = await axios.post( "/endpoints/user/profile", payload );

                if ( response.data.success )
                {
                    commit( "userProfile", response.data );
                }
                else
                {
                    //we should redirect else where, the user is not connected anymore
                }


                return response.data;
            },


            async loadData ( { commit }, payload )
            {
                for ( let i = 0; i < payload.length; i++ )
                {
                    let obj = payload[ i ];
                    let key = obj.key;

                    if ( !state.datastore[ key ] )
                    {
                        let response = await axios.get( obj.url );

                        commit( "datastore", { key, data : response.data } )
                    }
                }
            },
        }


let mutations =
        {

            copydeck ( state, payload )
            {
                state.copydeck = payload;
            },

            form ( state, payload )
            {
                state.form = payload;

                state.currentGroup = 0;
                state.totalGroup   = payload.data.groups.length;
            },

            user ( state, payload )
            {
                state.user = payload;
            },

            name (state, name)
            {
                state.user.name = name;
                state.user.profile.name = name;
            },

            email (state, email)
            {
                state.user.email = email;
                state.user.profile.email = email;
            },



            userProfile ( state, payload )
            {
                // let user     = payload.user;
                // user.profile = payload;

                state.user = payload.user;

            },

            currentGroup ( state, payload )
            {
                state.currentGroup = payload;
            },

            incrementCurrentGroup ( state )
            {
                state.currentGroup++;
            },


            datastore ( state, payload )
            {
                state.datastore[ payload.key ] = payload.data;
            },

            ready ( state )
            {
                state.ready = true;
            },


            avatars ( state, payload )
            {
                state.avatars = payload;
            },

            availableAvatars ( state, payload )
            {
                state.availableAvatars = payload;
            },

            avatarFrames ( state, payload )
            {
                state.avatarFrames = payload;

            },

            defaultAvatarId ( stat, payload )
            {
                state.defaultAvatarId = payload;
            },
        }


export default createStore( { state, getters, actions, mutations } );

